export class Mark {
  id: string;
  items: MarkItem[];
  schemaVersion: string;
  isDeleted: boolean;
  isValid: boolean;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
}

export class MarkItem {
  identifier: number;     // 0/1/2/3/4
  code: string;   // X/A/B/C/D
  label: string;  // No Mark/Accepted/Review Minor/Review Major/Rejected
  color: string;  // #XXXXXX
}

export class MarkUpsert {
  items: MarkItem[];
  schemaVersion: string;
}
